'use client'

import { Skeleton } from '@wiggui/ds/Skeleton'

import { WALKABILITY_LEVELS, WalkabilityLevel } from '../utils'
import { PercentageChart } from './percentage-chart'
import { composeClasses } from '@wiggot/utils'

interface MobilityChartProps {
  walkabilityLevel: WalkabilityLevel
  walkabilityScale: number
  isLoading?: boolean
  column?: boolean
}

export const MobilityChart = ({
  walkabilityLevel,
  walkabilityScale,
  isLoading,
  column = false
}: MobilityChartProps) => {
  const walkability = WALKABILITY_LEVELS[walkabilityLevel]

  if (isLoading) {
    return <Skeleton width="w-full" height="h-[168px]" />
  }

  if (!walkability) {
    return null
  }

  return (
    <div
      className={composeClasses(
        'flex justify-between items-center w-full p-4 bg-white border border-strokes rounded-xl',
        column ? 'flex-col h-[230px]' : 'flex-row h-[175px]'
      )}
    >
      <div
        className={composeClasses(
          'flex flex-col h-full',
          column ? 'w-full gap-4' : 'w-1/2 gap-6'
        )}
      >
        <div
          className={composeClasses(
            'flex items-center',
            column ? 'gap-1' : 'gap-2'
          )}
        >
          {walkability?.icon}
          <div className="text-sm leading-4 font-bold">
            <p className="text-body-m font-normal text-secondary">Movilidad</p>
            <p className="text-body-l">{walkability?.title}</p>
          </div>
        </div>
        <p className="text-body-s font-normal text-secondary">
          {walkability?.description}
        </p>
      </div>
      <div
        className={composeClasses(
          'flex items-end h-full',
          column ? 'w-full justify-center' : 'w-1/2 justify-end'
        )}
      >
        <div
          className={composeClasses(
            'relative',
            column
              ? 'max-h-[80px] max-w-[160px]'
              : 'max-h-[106px] max-w-[212px]'
          )}
        >
          <PercentageChart
            score={walkabilityScale}
            color={walkability?.color ?? ''}
          />
          <div className="absolute bottom-0 w-full">
            <div className="flex justify-center items-center">
              <p
                style={{ color: walkability?.color }}
                className="text-2xl font-semibold"
              >
                {walkabilityScale}
              </p>
            </div>
            <p className="text-body-s font-normal text-secondary text-center">
              de 100 puntos
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
